export enum Case {
  camel,
  kebab,
  pascal,
  snake,
  title
}

const wordSearch = /([a-z])(?=[A-Z0-9])|([0-9])(?=\D)|[^0-9a-zA-Z]+|([A-Z])(?=[A-Z][a-z])/g;

export function convertCase(
  value: string,
  caseToUse: Case
): string {
  const words = value.replace(wordSearch, '$1$2$3 ').trim().split(/\s+/);

  switch (caseToUse) {
    case Case.camel: {
      const pascalCase = convertCase(value, Case.pascal);
      return pascalCase[0].toLowerCase() + pascalCase.slice(1);
    }
    case Case.kebab:
      return words.join('-').toLocaleLowerCase();
    case Case.pascal:
      return titleCaseWords(words).join('');
    case Case.snake:
      return words.join('_').toLocaleLowerCase();
    case Case.title:
      return titleCaseWords(words).join(' ');
  }
}

function titleCaseWords(words: string[]): string[] {
  return words.map((word) => {
    return (word[0] ?? '').toUpperCase() + word.slice(1);
  });
}
